/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { LicenseStatusStore } from '../stores';

export const LicenseStatusContext = createContext<LicenseStatusStore>({} as LicenseStatusStore);
